import '@abb/abb-common-ux-react/styles.css';
import './App.less';
import * as React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { AuthProvider } from 'oidc-react';
import { oidcConfig } from './lib/appconst';
import ProtectedRoute from './components/Router/ProtectedRoute';
import AppLayout from './components/Layout/AppLayout';
import IWorldLayout from './components/Layout/IWorldLayout';
import LoadableComponent from './components/Loadable';
import utils from './utils/utils';
import './scenes/IWorld/IWorld.less';
declare var abp: any;

const App: React.FC = () => {
  // route path name
  const { pathname } = useLocation();

  // set title
  React.useEffect(() => {
    const title = utils.getPageTitle(pathname);
    document.title = title;
  }, [pathname]);

  return (
    <Switch>
      <Route path="/pms" component={LoadableComponent(() => import('./components/Layout/PMSLayout'))} />
      <Route
        path="/account/slientcallback"
        component={LoadableComponent(() => import('./components/Layout/PMSLayout'))}
      />
      <Route
        path="/account/external-entry"
        component={LoadableComponent(() => import('./scenes/Account/ExternalEntry'))}
      />
      <AuthProvider {...oidcConfig}>
        {/*<ProtectedRoute path="/" render={(props: any) => <AppLayout {...props} exact />} />*/}
        {
          abp.utils.getCookieValue('Abp.Login.UserType') == "IWorld" ?
            <ProtectedRoute path="/IWorldDashboard" render={(props: any) => <IWorldLayout {...props} exact />} />
            :
            <ProtectedRoute path="/" render={(props: any) => <AppLayout {...props} exact />} />
        }
      </AuthProvider>
    </Switch>
  );
};

export default App;
